import { render, staticRenderFns } from "./branchverifydiff.vue?vue&type=template&id=d4767390&scoped=true&"
import script from "./branchverifydiff.vue?vue&type=script&lang=js&"
export * from "./branchverifydiff.vue?vue&type=script&lang=js&"
import style0 from "./branchverifydiff.vue?vue&type=style&index=0&id=d4767390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4767390",
  null
  
)

export default component.exports